import { useMemo } from 'react';

import {
  ChakraAvatar,
  ChakraBadge,
  ChakraFlex,
  ChakraText,
  EquipUITheme,
} from '@equip.health/ui';

import { getPreferredFullName } from '~/lib/util/patient.util';

const { caption, captionBold, paragraph } = EquipUITheme.typography;

interface AttendeeListItemProps {
  attendee: ScheduleAttendee;
}

const TOP_LEVEL_ID = 'schedule-attendee';

const AttendeeListItem = ({ attendee }: AttendeeListItemProps) => {
  const {
    externalId,
    chosenName,
    firstName,
    isHost,
    isShowAvatar,
    lastName,
    name: attendeePreferredFullName,
    type,
  } = attendee;
  const name = useMemo(
    () =>
      attendeePreferredFullName ||
      getPreferredFullName(chosenName, firstName, lastName),
    [firstName, lastName],
  );
  return (
    <ChakraFlex alignItems="center" gridGap="12px">
      {isShowAvatar && (
        <ChakraAvatar
          background="secondary.50"
          color="neutral.background.primary"
          height="28px"
          id={`${TOP_LEVEL_ID}__${externalId}__user-avatar-card__avatar`}
          name={name}
          overflow="hidden"
          size="sm"
          width="28px"
        />
      )}
      <ChakraFlex alignItems="start" gridGap="12px">
        <ChakraFlex direction="column">
          <ChakraText
            {...paragraph}
            id={`${TOP_LEVEL_ID}__${externalId}__name`}
          >
            {name}
          </ChakraText>
          <ChakraText {...caption} id={`${TOP_LEVEL_ID}__${externalId}__type`}>
            {type}
          </ChakraText>
        </ChakraFlex>
        <ChakraFlex paddingTop="5px">
          {isHost && (
            <ChakraBadge
              {...captionBold}
              backgroundColor="neutral.background.secondary"
              borderRadius="100px"
              color="neutral.secondary"
              id={`${TOP_LEVEL_ID}__${externalId}__host-badge`}
              marginX="6px"
              padding="4px 8px"
              textTransform="capitalize"
            >
              Organizer
            </ChakraBadge>
          )}
        </ChakraFlex>
      </ChakraFlex>
    </ChakraFlex>
  );
};

export default AttendeeListItem;
